import { http } from "./http.js";

async function getRelationsMap(resource, id) {
  const response = await http.get(`${resource}/${id}/relations-map`);
  return response;
}

export { getRelationsMap };
